import {RcFile} from "antd/es/upload";

const convertToWebP = async (file: RcFile): Promise<RcFile> => {
    // Nếu file đã là WebP thì trả về luôn
    if (file.type === 'image/webp') {
        return file;
    }

    // Kiểm tra file type hợp lệ
    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
        throw new Error('Unsupported file type. Only JPEG, PNG and WebP are supported.');
    }

    try {
        const imageBitmap = await createImageBitmap(file);
        const canvas = document.createElement('canvas');
        canvas.width = imageBitmap.width;
        canvas.height = imageBitmap.height;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
            throw new Error('Could not get canvas context');
        }

        ctx.drawImage(imageBitmap, 0, 0);

        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error('Failed to create blob'));
                    return;
                }

                const webpFile = new File([blob], file.name.replace(/\.\w+$/, '.webp'), {
                    type: 'image/webp'
                });

                resolve(webpFile as RcFile);
            }, 'image/webp');
        });
    } catch (error) {
        console.error('Error converting image:', error);
        throw error; // Re-throw để component cha có thể xử lý
    }
};

export {convertToWebP};